export enum ListTab {
  Component = 0,
  SUA = 1,
  UnitOperation = 2,
}
